import request from '@/services/base/request'

export default {
  initRepair: (data: any) => request('/password/reset/', 'post', data),
  passwordResetSendCode: (data: any) => request(`/password/reset/send/${data.sessionId}/`, 'post', data.payload),
  doneRepair: (data: any) => request(`/password/reset/confirm/${data.sessionId}/`, 'post', data.payload)
} as {[key: string]: MethodDecorator}
